import { render, staticRenderFns } from "./pop_AiCategorySearch.vue?vue&type=template&id=ca71ac72&scoped=true&"
import script from "./pop_AiCategorySearch.vue?vue&type=script&lang=js&"
export * from "./pop_AiCategorySearch.vue?vue&type=script&lang=js&"
import style0 from "./pop_AiCategorySearch.vue?vue&type=style&index=0&id=ca71ac72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca71ac72",
  null
  
)

export default component.exports